module.exports = __webpack_public_path__ + "media/images/menu/vela-93e1aa8e706f12f76e79d69eaacb261e.jpg";